import { AlertDTO } from 'features/alerts/api/types/alertDTO'
import { Alert } from 'features/alerts/types/alert'

export const alertsFromDTO = <T extends string>(alertsDTO: AlertDTO[]): Alert<T>[] =>
  alertsDTO.map(
    (alertDTO: AlertDTO): Alert<T> => ({
      description: alertDTO.description,
      name: alertDTO.name as T,
    }),
  )
